"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListingActivityListModel_1 = require("./ListingActivityListModel");
var getActivity = function (listing) {
    return listing.getState("activity", function () {
        return new ListingActivityListModel_1.ListingActivityListModel(listing);
    });
};
exports.getActivity = getActivity;
